<mat-card>
  <mat-card-content>
    <mat-card-title>
      Richiesta di adesione al GII
    </mat-card-title>
  </mat-card-content>
</mat-card>

<mat-card>
  <mat-card-content>
    <form [formGroup]='frmInserimento' class='inserimento-form'>
      <div fxLayout="row wrap" *ngIf="objdettaglio?.idReferenteTipologia== 1">
        <div fxFlex="100%;" fxFlex.xs="100%">
          <strong>* Tipo di adesione </strong> <br />
          <mat-radio-group [(ngModel)]="idTipoAdesione"
                           formControlName="idTipoAdesione" (ngModelChange)="getTipoAdesioneRadioButton($event)"
                           id="idTipoAdesione" name="idTipoAdesione"
                           required>
            <mat-radio-button *ngFor="let obj of lstElencoTipoAdesione" [value]="obj.idTipoAdesione">
              {{obj.DescrizioneTipoAdesione}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <div fxLayout="row wrap" *ngIf="objdettaglio?.idReferenteTipologia != 1">
        <div fxFlex="100%;" fxFlex.xs="100%">
          <strong>* Tipo di adesione</strong> <br />
          <!--fai apparire singolo e junior 35-->
          <mat-radio-group [(ngModel)]="idTipoAdesione" id="idTipoAdesione"
                           formControlName="idTipoAdesione"  (ngModelChange)="getTipoAdesioneRadioButton($event)"
                           name="idTipoAdesione" required>
            <mat-radio-button value="0">Normale</mat-radio-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <mat-radio-button value="1">Junior (Età < 35 anni, non strutturato)</mat-radio-button>
          </mat-radio-group>
          <!--   <mat-radio-group [(ngModel)]="idTipoAdesione" id="idTipoAdesione" name="idTipoAdesione">
        <mat-radio-button *ngFor="let obj of lstElencoTipoAdesione" [value]="obj.idTipoAdesione">
          {{obj.DescrizioneTipoAdesione}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </mat-radio-button>
      </mat-radio-group> -->
        </div>
      </div>


      <div fxLayout="row wrap">
        <div fxFlex="50%;" fxFlex.xs="100%">
          <mat-form-field class="full-width">
            <mat-select placeholder="Periodo" name="Descrizione" [(ngModel)]="Periodo" required
                        formControlName="Descrizione"
                        id="Descrizione">
              <mat-option *ngFor="let obj of lstPeriodi" [value]="obj.Descrizione">
                {{obj.Descrizione}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </form>
    <div fxLayout="row wrap">
      <div fxFlex="100%;" fxFlex.xs="100%">
        <fieldset>
          <legend>Socio collettivo</legend>

          <p><strong>Ateneo/Istituto di ricerca</strong> {{objdettaglio?.Ateneo}}</p>

          <p><strong>Dipartimento</strong> {{objdettaglio?.Dipartimento}}</p>
        </fieldset>
      </div>

      <div fxFlex="100%;" fxFlex.xs="100%">
        <fieldset>
          <legend>Referente</legend>

          <p><strong>Cognome</strong> {{objdettaglio?.Cognome}}</p>

          <p><strong>Nome</strong> {{objdettaglio?.Nome}}</p>

          <p><strong>Codice Fiscale</strong> {{objdettaglio?.CodiceFiscale}}</p>

          <p><strong>E-mail</strong> {{objdettaglio?.Email}}</p>
        </fieldset>
      </div>

      <div fxFlex="100%;" fxFlex.xs="100%" *ngIf="isEditTabella">
        <p>
          Sotto la lista degli utenti dello stesso dipartimento che non hanno ancora aderito per l'anno corrente<br />
          Cancellare le persone che non partecipano all'adesione
        </p>
      </div>

      <div fxFlex="100%;" fxFlex.xs="100%" *ngIf="isEditTabella">
        <fieldset>
          <legend>Persone aggiuntive</legend>
          <p></p>
          <mat-card>
            <mat-card-content>

              <ngx-datatable #grd
                             [rows]="lstElencoNominativi"
                             [columnMode]="'flex'"
                             [headerHeight]="50"
                             [footerHeight]="50"
                             [limit]="30"
                             [rowHeight]="'auto'">
                <!--
  <ngx-datatable-column name="" [flexGrow]="0.5">
    <ng-template let-row="row" ngx-datatable-cell-template>
      <div style="float:left">
        <button mat-icon-button mat-sm-button color="primary"
                class="mr-1"
                (click)="btnVisualizza(row)"
                matTooltip="Visualizza">
          <mat-icon>zoom_in</mat-icon>
        </button>
      </div>
    </ng-template>
  </ngx-datatable-column> -->


                <ngx-datatable-column name="" [flexGrow]="0.5">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <div style="float:left">
                      <button mat-icon-button mat-sm-button color="primary"
                              class="mr-1"
                              (click)="btnAggiungiNominativo(row)"
                              matTooltip="Modifica Nominativo">
                        <mat-icon>edit</mat-icon>
                      </button>
                    </div>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="" [flexGrow]="0.5">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <div style="float:left">
                      <button mat-icon-button mat-sm-button color="primary"
                              class="mr-1"
                              (click)="btnElimina(row)"
                              matTooltip="Elimina">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Cognome"
                                      [flexGrow]="1"
                                      [sortable]="true"
                                      prop="Cognome">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row?.Cognome }}
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Nome"
                                      [flexGrow]="1"
                                      [sortable]="true"
                                      prop="Nome">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row?.Nome }}
                  </ng-template>
                </ngx-datatable-column>



                <ngx-datatable-column name="Email"
                                      [flexGrow]="1.5"
                                      [sortable]="true"
                                      prop="Email">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row?.Email }}
                    <br />
                    <B>{{ row?.CodiceFiscale }}</B>
                  </ng-template>
                </ngx-datatable-column>




                <ngx-datatable-column name="Sett. Scientifico"
                                      [flexGrow]="1"
                                      [sortable]="true"
                                      prop="SettoreScientificoDescrizione">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row?.SettoreScientificoDescrizione }}
                  </ng-template>
                </ngx-datatable-column>

              </ngx-datatable>

            </mat-card-content>
          </mat-card>

          <br />
          <button mat-raised-button color="accent" (click)="btnAggiungiNominativo(-1)" *ngIf="objdettaglio?.idReferenteTipologia == 1">
            Aggiungi nominativo
          </button>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <button mat-raised-button color="accent" (click)="btnUtentiConUgualeDipartimento()" *ngIf="objdettaglio?.idReferenteTipologia == 1">
            Scegli nominativo
          </button>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <button mat-raised-button color="accent" (click)="btnAggiungiMeStesso()">
            Aggiungi me stesso
          </button>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <button mat-raised-button color="accent" (click)="btnMostraNominativi()">
            Mostra Nominativi
          </button>
        </fieldset>
      </div>
    </div>
    <br />
    <div class="row">
      <div fxFlex="100%;" fxFlex.xs="100%" align="center">
        <button mat-raised-button color="accent" (click)="btnAvanti()"  [disabled]="!frmInserimento.valid">
          AVANTI
        </button>
      </div>
    </div>

  </mat-card-content>
</mat-card>


